import { render, staticRenderFns } from "./lessonDetail2.vue?vue&type=template&id=28e130d0&scoped=true&"
import script from "./lessonDetail2.vue?vue&type=script&lang=js&"
export * from "./lessonDetail2.vue?vue&type=script&lang=js&"
import style0 from "./lessonDetail2.vue?vue&type=style&index=0&id=28e130d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e130d0",
  null
  
)

export default component.exports